import axios from "axios";
import useAuth from "./AuthHook";

const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:9100/'

export default function useApi() {

    const { token } = useAuth();

    const api = axios.create({
		baseURL: apiUrl,
        headers: {
            'Authorization': 'Bearer ' + token
        }
	});

    return api;
}